"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MzRemoveComponentHost = (function () {
    function MzRemoveComponentHost(elementRef) {
        this.elementRef = elementRef;
        this.childrenElement = [];
    }
    MzRemoveComponentHost.prototype.ngAfterViewInit = function () {
        var hostElement = this.elementRef.nativeElement;
        this.parentElement = hostElement.parentElement;
        // move child out of the host element
        while (hostElement.firstChild) {
            this.childrenElement.push(this.parentElement.insertBefore(hostElement.firstChild, hostElement));
        }
    };
    MzRemoveComponentHost.prototype.ngOnDestroy = function () {
        var _this = this;
        // remove moved out element
        this.childrenElement.forEach(function (childElement) { return _this.parentElement.removeChild(childElement); });
    };
    return MzRemoveComponentHost;
}());
/** @nocollapse */
MzRemoveComponentHost.ctorParameters = function () { return [
    { type: core_1.ElementRef, decorators: [{ type: core_1.Inject, args: [core_1.ElementRef,] },] },
]; };
exports.MzRemoveComponentHost = MzRemoveComponentHost;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/shared/remove-component-host/remove-component-host.js
// module id = ./node_modules/ng2-materialize/dist/shared/remove-component-host/remove-component-host.js
// module chunks = vendor